import { Injectable } from '@angular/core';

import { Role } from '@zeusm/business/core/entities';

@Injectable({
  providedIn: 'root',
})
export class BusinessDictionariesService {
  readonly #statuses = new Map([
    ['Active', 'dictionary.status.card.active'],
    ['Invited', 'dictionary.status.card.invited'],
    ['Blocked', 'dictionary.status.card.blocked'],
    ['ActiveCard', 'dictionary.status.card.activeCard'],
    ['BlockedCard', 'dictionary.status.card.blockedCard'],
    ['ClosedCard', 'dictionary.status.card.closedCard'],
    ['Failed', 'dictionary.status.card.failed'],
    ['Creating', 'dictionary.status.card.creating'],
    ['Closing', 'dictionary.status.card.closing'],
    ['Blocking', 'dictionary.status.card.blocking'],
    ['Unblocking', 'dictionary.status.card.unblocking'],
  ]);

  roles = new Map<Role, string>([
    [Role.Admin, 'dictionary.role.admin'],
    [Role.SuperAdmin, 'dictionary.role.superAdmin'],
    [Role.Buyer, 'dictionary.role.buyer'],
    [Role.Supervisor, 'dictionary.role.supervisor'],
    [Role.AAOwner, 'dictionary.role.owner'],
    [Role.AAManager, 'dictionary.role.manager'],
    [Role.AASupervisor, 'dictionary.role.aaSupervisor'],
  ]);

  getStatus(status: string): string | undefined {
    return this.#statuses.get(status);
  }
}
